import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../../core';
import { PedidoSetorGepAguardandoProducao } from '../pedido-setor-gep-aguardando-producao';

@Injectable({
    providedIn: 'root'
})
export class PedidoSetorGepAguardandoProducaoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApi()}/pedidogep`;
    }

    /** Inicia o aguardando produção do pedido */
    find(idPedido: number): Observable<PedidoSetorGepAguardandoProducao> {
        return this.customHttp.get<PedidoSetorGepAguardandoProducao>(`${this.pathApi}/${idPedido}/aguardandoproducao`);
    }

    /** Inicia o aguardando produção do pedido */
    iniciar(idPedido: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${idPedido}/aguardandoproducao/iniciar`, null);
    }

    /** Termina o aguardando produção do pedido */
    terminar(idPedido: number): Observable<string> {
        return this.customHttp.put<string>(`${this.pathApi}/${idPedido}/aguardandoproducao/terminar`, null);
    }
}
